import { SocialSharing } from '@ionic-native/social-sharing'
import { IonActionSheet, IonAvatar, IonButton, IonButtons, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonModal, IonRow, IonText, IonTitle, IonToolbar, isPlatform } from '@ionic/react'
import { addOutline, calendar, caretDown, chatbox, close, copy, create, documentText, ellipsisHorizontal, list, lockClosed, mailOutline, mic, pencil, people, person, shareSocial, trash, walk } from 'ionicons/icons'
import React, { useState, useEffect } from 'react'
import { openChat } from '../../helpers/chat_actions'
import { formatDate, formatEnd } from '../../helpers/format_date'
import { editWalk, removeWalk } from '../../helpers/walk_actions'
import { BookedPerson } from '../../interfaces/Walk'
import GoogleMap from '../GoogleMap'
import history from '../../helpers/history';
import { goToPage, goToPageWithState } from '../../helpers/app_actions'
import Api from "../../services/Api"
import WalkCalendar from '../WalkCalendar'
import { ShareWalk } from '../ShareWalk'
import { NoteInterface } from '../Notes'
import { useSelector, useDispatch } from 'react-redux';
import { closePreview } from '../../redux/actions/walkPreview'
import { RootState } from '../../redux/reducers'
import { getMyWalks } from '../../redux/actions/walkActions'
import { removeMyWalk } from '../../redux/actions/removeWalkActions'

interface PopoverInterface {
  showPopover: boolean, 
  bookedPersons: Array<BookedPerson>
}

export const WalkModal = () => {
  const api = Api.getInstance()
  const dispatch = useDispatch()
  const isOpen = useSelector((state: RootState) => state.preview.isOpen)
  const setWalk = useSelector((state: RootState) => state.preview.walk)
  const myWalk = setWalk.editable ? true : false
  const [showPopover, setShowPopover] = useState<PopoverInterface>({
    showPopover: false, 
    bookedPersons: [],
  })
  const [state, setState] = useState({
    showActionSheet: false,
    actionSheetButtons: '',
    showCalendar: false,
    addCalendar: false,
    addedCalendar: false,
    removeCalendar: false,
    shareUrlCopied: false,
    shareLink:  setWalk.inviteOnly ? 'https://app.walkingtalking.com/walk/share/privatewalk/' + setWalk.id : 'https://app.walkingtalking.com/walk/sharewalk/' + setWalk.id 
  })
  const [shareLink, setShareLink] = useState({ shareLink: '' , shareUrlCopied: false })
  const [notes, setNotes] = useState({
    notes: [] as Array<NoteInterface>
  })


  useEffect(() => {
    if(setWalk.id) {
      getNotes()
    }
  }, [setWalk.id]) // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   console.log(showModal)
  // }, [showModal])

  const myWalkButtons = [{
    text: api.tr('edit_walk'),
    icon: create,
    handler: () => {
      console.log('click')
      closeModal()
      editWalk(history, setWalk.id)
    }
  }, {
    text: api.tr('share_walk'),
    icon: shareSocial,
    handler: () => {
      closeModal()
      shareWalk(setWalk.id)
    }
  }, {
    text: api.tr('copy_walk'),
    icon: copy,
    handler: () => {
      closeModal()
      copyWalk()
    }
  }, {
    text: api.tr('add_to_calendar'),
    icon: addOutline,
    handler: () => {
      setState({...state, addCalendar: true})
    }
  }, {
    text: api.tr('remove_walk'),
    role: 'destructive',
    icon: trash,
    handler: () => {
      removeWalk(setWalk.id).then(res => {
        dispatch(removeMyWalk(res.id))
        dispatch(getMyWalks())
        closeModal()
      })
    }
  }]

  const closeModal = () => {
    dispatch(closePreview(setWalk))
  }

  const bookedWalk = [{
    text: api.tr('add_to_calendar'),
    icon: addOutline,
    handler: () => {
      setState({...state, addCalendar: true})
    }
  }]

  const copyWalk = () => {
    history.push({
      pathname: '/walk/copy',
      state: setWalk
    })
  }

  const getNotes = () => {
    api.get('notes/list/' + setWalk.id).then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          if(data.walks.length > 0) {
            setNotes({
              notes: data.walks[0].notes
            })
          } else {
            setNotes({
              notes: []
            })
          }
        }
      })
    })
  }

  const shareWalk = (walkId: number) => {
    const shareUrl = setWalk.inviteOnly ? 'https://app.walkingtalking.com/walk/share/privatewalk/' + setWalk.id : 'https://app.walkingtalking.com/walk/sharewalk/' + setWalk.id

    if (isPlatform('capacitor')) {
      const message = api.profile.firstName + api.tr('has_shared_walk_message')

      SocialSharing.share(message, 'Walking Talking', '', shareUrl)
    } else {
      setShareLink({
        ...shareLink, shareLink: shareUrl
      })
    }
  }
  
  const toolBar = () => {
    if(myWalk) {
      return <IonToolbar color="teal">
        <IonButtons slot="start" class="flex justify-between fullWidth">
          <IonButton onClick={() => {
            closeModal()
            editWalk(history, setWalk.id)
            }}>
            <IonIcon icon={pencil} size="large" color="light"/>
          </IonButton>
          { setWalk.booked ? 
            <IonButton onClick={() => {
              if(setWalk.maxBookings > 1) {
                setShowPopover({ showPopover: true, bookedPersons: setWalk.bookedPersons})
              } else {
                if(setWalk.bookedPerson) { 
                  openChat(setWalk.bookedPerson.id)
                } else {

                } 
              }}}>
              <IonIcon icon={chatbox} size="large" color="light"/>
            </IonButton>
          : null }
          { setWalk.hasTalk ? 
          <IonButton onClick={() => {
            // setShowModal(false)
            closeModal()
            goToPageWithState('/walk/walk/' + setWalk.id, 'openCall')
          }}>
            <IonIcon icon={mic} size="large" color="light"/>
          </IonButton> : null }
           
          <IonButton onClick={() => {
            // setShowModal(false)
            closeModal()
            goToPageWithState('/walk/walk/' + setWalk.id, 'openNote')
          }}>
            <IonIcon icon={documentText} size="large" color="light"/>
          </IonButton>
          <IonButton onClick={() => shareWalk(setWalk.id)}>
            <IonIcon icon={shareSocial} size="large" color="light"/>
          </IonButton>
          <IonButton onClick={() => {
            setState({
              ...state,
              showActionSheet: true
            })}}>
            <IonIcon icon={ellipsisHorizontal} size="large"  color="light"/>
          </IonButton>
        </IonButtons>
      </IonToolbar>
    } else {
      return <IonToolbar color="teal">
        <IonButtons slot="start" class="flex justify-between fullWidth">
          <IonButton onClick={() => {
            if(setWalk.maxBookings > 1) {
              setShowPopover({ showPopover: true, bookedPersons: setWalk.bookedPersons})
            } else {
              openChat(setWalk.personId)
            }
          }}>
            <IonIcon icon={chatbox} size="large" color="light"/>
          </IonButton>
          { setWalk.hasTalk ? 
          <IonButton onClick={() => {
            // setShowModal(false)
            closeModal()
            goToPageWithState('/walk/walk/' + setWalk.id, 'openCall')
            }}>
          <IonIcon icon={mic} size="large" color="light"/>
          </IonButton> : null }
          <IonButton onClick={() => {
            // setShowModal(false)
            closeModal()
            goToPageWithState('/walk/walk/' + setWalk.id, 'openNote')
          }}>
            <IonIcon icon={documentText} size="large" color="light"/>
          </IonButton>
          <IonButton onClick={() => {
            setState({
              ...state,
              showActionSheet: true
            })
          }}>
            <IonIcon icon={ellipsisHorizontal} size="large"  color="light"/>
          </IonButton>
        </IonButtons>
    </IonToolbar>
    }
  }

  const bookedBy = () => {
    if(setWalk.booked) {
      if(setWalk.bookings > 1) {
        return <IonItem>
          <IonIcon icon={people} size="small" slot="start"/>
          { setWalk.maxBookings > 1 ?
          <IonChip 
            onClick={() => setShowPopover({ showPopover: true, bookedPersons: setWalk.bookedPersons})}
            class="p-2 ml-2">
            {setWalk.bookings} / {setWalk.maxBookings} 
            <IonIcon icon={caretDown}/>
            <IonModal
              class="sheetModal"
              breakpoints={[0.1, 0.5, 1]}
              initialBreakpoint={0.5}
              className='my-custom-class'
              isOpen={showPopover.showPopover}
              onDidDismiss={() => {
                setShowPopover({ 
                  showPopover: false, 
                  bookedPersons: [] 
                  })}
              }>
              <IonList class="mb-2">
                <IonListHeader class="p-2">
                  Gäster
                </IonListHeader>
                { setWalk.bookedPersons && setWalk.bookedPersons.map((person: any, key: number) => (
                  <IonItem key={person.id + key} onClick={() => {
                    // setShowModal(false)
                    closeModal()
                    goToPage('/walk/chat/' + person.id)
                  }}>
                    <IonAvatar slot="start">
                      <img src={person.personPicture} alt=""/>
                    </IonAvatar>
                    <IonLabel class="ml-2">
                      {person.firstName}
                    </IonLabel>
                    <IonIcon icon={mailOutline}/>
                  </IonItem>
                ))}
              </IonList>
            </IonModal>
          </IonChip>
        : null }
        </IonItem>
      } else {
        return <IonItem>
        <IonIcon icon={person} size="small" slot="start"/>
        <IonAvatar class="ml-2">
          <img src={setWalk.bookedPerson?.personPicture} alt=""/>
        </IonAvatar>
        <IonCol class="ml-2">
          <IonLabel>{setWalk.bookedPerson?.firstName}</IonLabel>
          <IonText class="font_small">Booked</IonText>
        </IonCol>
      </IonItem>
      }
    } else {
      return <IonItem>
        <IonIcon icon={people} size="small" slot="start"/> 
        <IonText class="ml-2">{api.tr('not_booked_walk_card')}</IonText>
      </IonItem>
    }
  }

  const exitCal = (action: string) => {
    if (action === 'delete') {
      setState({
        ...state,
        removeCalendar: false
      })
    } else if (action === 'add') {
      setState({
        ...state,
        addCalendar: false, 
        addedCalendar: true
      })
    } else {
      setState({
        ...state,
        addCalendar: false
      })
    }
  }

  return (
    <IonModal
      isOpen={isOpen}
      class="sheetModal"
      breakpoints={[0.1, 0.5, 1]}
      initialBreakpoint={0.5}
      onDidDismiss={() => closeModal()}>
      <IonHeader>
        <IonToolbar class="">
        { setWalk.hasTalk && setWalk.hasCoordinates ? 
          <IonChip slot="start" color="darkblue" className="p-2 ml-2 flex justify-center items-center">
            <IonIcon icon={mic}  color="darkblue" size="small"/>
            / 
            <IonIcon icon={walk}  color="darkblue" size="small"/>
          </IonChip>
          : 
          <IonChip slot="start" color="darkblue" className="p-2 ml-2 flex justify-center items-center">
            { setWalk.hasTalk ?
            <IonIcon icon={mic} size="small" color="darkblue"/> :
            <IonIcon icon={walk} size="small" color="darkblue"/>
              }
          </IonChip>
        }
          <IonGrid class="ml-2">
            <IonRow>
              <IonTitle>{setWalk.name}</IonTitle>
            </IonRow>
          </IonGrid>
          <IonButtons slot="end">
            <IonButton onClick={() => {
              closeModal()
              // setShowModal(false)
              }}>
              <IonIcon icon={close} size="large"/>
            </IonButton>
          </IonButtons>
        </IonToolbar>
        <IonRow class="py-2 px-4">
          <IonText>
            {formatDate(setWalk.start)}-{formatEnd(setWalk.start, setWalk.lengthMinutes)}
          </IonText>
        </IonRow>
        { setWalk.editable ? toolBar() : null }
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow></IonRow>
          <IonRow>

          </IonRow>
          <IonRow class="fullWidth">
            <IonList class="fullWidth">
              <IonItem class="fullWidth">
                <IonIcon icon={calendar} size="small" slot="start"/>
                <IonAvatar class="ml-2">
                  <img src={setWalk.personPicture} alt=""/>
                </IonAvatar>
                <IonCol class="ml-2">
                  <IonLabel>{setWalk.personName}</IonLabel>
                  <IonText class="font_small">{api.tr('organiser')}</IonText>
                </IonCol>
              </IonItem>
              { !setWalk.editable  ? null : bookedBy() }
            </IonList>
          </IonRow>
          { !setWalk.editable  ? null : 
          <IonRow>
            <IonChip class="p-2 m-2" color="teal">
              <IonIcon icon={list} />
              { notes.notes.filter(note => note.noteType === 1).length }
            </IonChip>
            <IonChip class="p-2 m-2" color="teal">
              <IonIcon icon={documentText} />
              { notes.notes.filter(note => note.noteType === 0).length }
            </IonChip>
            <IonChip class="p-2 m-2" color="teal">
              <IonIcon icon={lockClosed} />
              { notes.notes.filter(note => note.noteType === 0 && note.private).length }
            </IonChip>
          </IonRow>
          }
          <IonRow class="p-2">
            {setWalk.description}
          </IonRow>
          <IonRow>
            <IonButton class="fullWidth m-2" onClick={() => {
              // setShowModal(false)
              closeModal()
              goToPage('/walk/walk/' + setWalk.id)
              }}>
              {api.tr('go_to_walk')}
            </IonButton>
          </IonRow>
          {setWalk.hasCoordinates ? 
          <IonRow>
            <GoogleMap
              lat={setWalk.lat} 
              lng={setWalk.lng} 
              zoom={setWalk.zoom}
              placeName={setWalk.placeName} 
              fixedMarker={false} 
              height={50}/>
          </IonRow>
          : null }
        </IonGrid>
      </IonContent>
      <IonActionSheet
        isOpen={state.showActionSheet}
        onDidDismiss={() => setState({...state, showActionSheet: false})}
        cssClass='my-custom-class'
        buttons={setWalk.editable ? myWalkButtons : bookedWalk }/>
      <IonModal 
        isOpen={state.addCalendar} 
        onDidDismiss={() => setState({
          ...state,
          addCalendar: false
          })}>
        <WalkCalendar 
          exitCal={exitCal} 
          walk={setWalk} 
          action="add"/>
      </IonModal>
      <ShareWalk 
        isOpen={shareLink.shareLink.length > 0}
        walkId={setWalk.id}
        shareLink={shareLink}
        setShareLink={setShareLink}/>
    </IonModal>
  )
}
